import { useEffect, useState } from "react";
import { IAliasOption, transplantedUtility } from "../transplanted/models";
import { Typeahead } from "react-bootstrap-typeahead";
import { Alert, FormControl } from "react-bootstrap";
import { IRecipientForTransplantedList } from "@nkr/store/microsites";
import { INkrRecipientsForMicrositeResponse } from "@nkr/store/microsites/actions-transplanted";
import { connect, Dispatch } from "react-redux";
import { IApplicationState, MicrositeActionCreators } from "@nkr/store/index";
import { Highlighter } from "react-bootstrap-typeahead";

interface IProps {
    micrositeId: number,
    value: number,
    enabled: boolean,
    onChange: (v: number) => void,
}

interface IStateProps { }

interface IDispatchProps {
    getNkrRecipientsForMicrosite: (micrositeId: number) => Promise<INkrRecipientsForMicrositeResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

const NkrRecipientTypeahead = ({ micrositeId, value, enabled, onChange, getNkrRecipientsForMicrosite }: TProps) => {
    const [nkrRecipients, setNkrRecipients] = useState<IRecipientForTransplantedList[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    console.log(micrositeId);

    useEffect(() => {
        setIsLoading(true);

        getNkrRecipientsForMicrosite(micrositeId)
            .then(r => {
                setNkrRecipients(r.data.results);
            })
            .catch((ex) => {
                setError(ex);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [micrositeId]);

    const nkrAliasOptionList: IAliasOption[] = nkrRecipients?.map(r => {
        return transplantedUtility.createAliasOption(r);
    });

    const selected = nkrAliasOptionList.filter(o => o.id == value)

    const handleChange = (v: IAliasOption) => {
        onChange(v[0]?.id)
    }

    if (error) {
        return <Alert bsStyle='danger'>An error occurred while retrieving aliases. If this error persists please contact support.</Alert>;
    }

    if (isLoading) {
        return <Alert bsStyle='info'>Loading Aliases ...</Alert>
    }

    return (<>
        <Typeahead
            id='nkr-alias'
            clearButton={true}
            labelKey={option => `${option.alias} ${option.firstName} ${option.lastName} ${option.birthDate} ${option.transplantDate}`}
            options={nkrAliasOptionList}
            selected={selected}
            disabled={!enabled}
            filterBy={['alias', 'firstName', 'lastName', 'birthDate', 'transplantDate']}
            renderInput={(inputProps) => (
                <FormControl {...inputProps} />
            )}
            renderMenuItemChildren={(option, props) => {
                return (
                    <div style={{ borderBottom: '1px solid #ddd', paddingBottom: 5 }}>
                        <div>Alias: <Highlighter search={props.text}>{option.alias}</Highlighter></div>
                        {option.firstName != '' && option.lastName != '' && (
                            <div><small>Name: <Highlighter search={props.text}>{`${option.firstName} ${option.lastName}`}</Highlighter></small></div>
                        )}
                        <div><small>DOB: <Highlighter search={props.text}>{option.birthDate}</Highlighter></small></div>
                        <div><small>Transplanted: <Highlighter search={props.text}>{option.transplantDate}</Highlighter></small></div>
                    </div>
                );
            }}
            onChange={handleChange}
        />
    </>);
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        getNkrRecipientsForMicrosite: (micrositeId) => {
            return dispatch(MicrositeActionCreators.getNkrRecipientsForMicrosite(micrositeId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(NkrRecipientTypeahead);